<template>
    <div id="verified">
        <div class="card-other">
            <h4>尊敬的用户,为了贯彻工信部《电话用户真实身份信息登记规定》,请对您的卡板进行车联网认证。</h4>
            <br />
            <br />
            <div class="main">
                <form>
                    <div class="title">上传身份证正面</div>
                    <div class="many">
                        <div class="uploadOuter">
                            <img src="@/assets/zheng.png">
                        </div>
                        <div class="uploadOuter">
                            <input type="file" ref="file1" @change="showImg($event, 'existFrontImg', 'frontImgUrl')"
                                :disabled="disabledFlag">
                            <div v-if="!existFrontImg">点击上传身份证正面</div>
                            <img v-else :src="frontImgUrl" alt="">
                        </div>
                    </div>

                    <br />
                    <br />

                    <div class="title">上传身份证反面</div>
                    <div class="many">
                        <div class="uploadOuter">
                            <img src="@/assets/fan.png">
                        </div>
                        <div class="uploadOuter">
                            <input type="file" ref="file3" @change="showImg($event, 'existHandImg', 'handImgUrl')"
                                :disabled="disabledFlag">
                            <div v-if="!existHandImg">点击上传身份证反面</div>
                            <img v-else :src="handImgUrl" alt="">
                        </div>
                    </div>
                    <div class="btnOuter">
                        <van-button class="bu_tn-b" round block type="info" native-type="submit"
                            @click="sureVerifiedHandler">提 交 认 证</van-button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { wxRequest, verified } from '@/api/user'
import { Toast } from 'vant'
import { Dialog } from 'vant';
export default {
    data() {
        return {
            setPay: localStorage.getItem('iccid'),
            recordLoginText: localStorage.getItem('recordLoginText'),
            state: '',
            supplierTypeCode: '',
            verifiedInfo: {
                iccid: localStorage.getItem('iccid'),
            },
            disabledFlag: false,
            existFrontImg: false,
            existBackImg: false,
            existHandImg: false,
            frontImgUrl: '',
            backImgUrl: '',
            handImgUrl: '',
            cuccAuth: ''
        }
    },
    methods: {
        sureVerifiedHandler() {
            let _this = this;
            var iccid = localStorage.getItem('iccid');
            let formData = new FormData();
            formData.append('iccid', iccid);
            formData.append('imgFront', this.$refs.file1.files[0]);
            formData.append('imgBack', this.$refs.file3.files[0]);
            wxRequest('sim/insertAuth', formData, 'post').then(res => {
                if (res.data.code === '200') {
                    Toast.loading({ message: '实名认证审核中...', duration: 0, forbidClick: true });
                    var timer = setInterval(() => {
                        clearInterval(timer)
                        Toast.clear();
                        Dialog.alert({ title: "审核通知", message: '实名认证成功，即将跳转页面！' });
                        _this.$router
                            .push({
                                path: "/user/homeTwo",
                                query: {
                                    iccid: _this.$store.state.iccid,
                                },
                            })
                            .catch(() => { });
                    }, 1500)
                } else {
                    Dialog.alert({ title: "提示", message: res.data.message });
                }
            })
        },
        showImg(event, showImgkey, imgUrl) {
            this.$data[showImgkey] = true;
            const files = event.target.files
            let filename = files[0].name          //只有一个文件
            if (filename.lastIndexOf('.') <= 0) {
                return alert("Please add a valid image!")        //判断图片是否有效
            }
            const fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.addEventListener('load', () => {
                this.$data[imgUrl] = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.image = files[0]
        }
    },
    created() {

    },

    mounted() {

    },

    quitHome() {
        this.$router.push({
            path: "/user/home",
        });
    }

}
</script>
<style lang="less">
#verified {
    height: 100%;

    h4 {
        color: #fff;
        font-size: 10px;
        background: #ff9c3c;
        line-height: 1.5em;
        padding: 6px 3%;
    }

    .main {
        height: calc(100% - 48px);
        padding: 0 4%;

        form {
            height: 100%;
        }

        .line {
            border-bottom: 1px solid #e5e5e5;
        }

        .many {
            display: flex;
            justify-content: space-between;

            label {
                display: block;
                line-height: 36px;
            }

            .uploadOuter {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 48%;
                height: 100px;
                border: 1px dashed #e5e5e5;
                box-sizing: border-box;

                input[type=file] {
                    position: absolute;
                    top: 0;
                    width: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .title {
            line-height: 28px;
            margin-top: 10px;
        }

        .btnOuter {
            display: flex;
            align-items: center;
            height: calc(100% - 424px; )
        }
    }


    .card-dianxin {
        width: 100%;
        height: 100%;

        h1 {
            font-size: 14px;
            background: #fff;
            line-height: 1.5em;
            padding: 6px 3%;
        }

        .dianxin-iframe {
            width: 100%;
            height: 100%;
        }
    }

    .card-yidong {
        width: 100%;
        height: 100%;

        h1 {
            font-size: 16px;
            background: #fff;
            line-height: 1.5em;
            padding: 3px 3%;
        }

        .dianxin-iframe {
            width: 100%;
            height: 100%;
        }
    }

    .card-other {
        width: 100%;
        height: 100%;
    }

}
</style>
